// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1C5xk","inputWrap":"Table_inputWrap__3SrLz","col":"Table_col__3xMXY","bmiTooltip":"Table_bmiTooltip__3967B"};